/** Must be in sync with fleet backend equivalent enum  */
export enum IdentityTypes {
	System = 'system',
	ClientSecret = 'clientSecret',
	Moderator = 'moderator',
	Driver = 'driver',
	Passenger = 'passenger',
	Parent = 'parent',
	Automation = 'automation',
	SuperAdmin = 'superadmin',
}
